export const arbitraryMenu = ["Últimos Lançamentos"];

export const arbitrarySubmenu = ["Últimos Lançamentos", "Comece por aqui"];

export const filterAndOrderMenu = (categoriesArray) => {
  return categoriesArray
    .filter((category) => {
      if (arbitraryMenu.includes(category.title)) return true;
      return false;
    })
    .sort(
      (a, b) => arbitraryMenu.indexOf(a.title) - arbitraryMenu.indexOf(b.title)
    );
};
export const getSubmenuHeaderCategories = (categoriesArray) => {
  return categoriesArray.filter((category) => {
    if (arbitrarySubmenu.includes(category.title)) return true;
    return false;
  });
};
